"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ButtonModule = _interopRequireDefault(require("./Button.module.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Button = function Button(_ref) {
  var disabled = _ref.disabled,
      children = _ref.children,
      onClickMethod = _ref.onClickMethod;
  return /*#__PURE__*/_react["default"].createElement("button", {
    disabled: disabled,
    className: _ButtonModule["default"].button,
    onClick: onClickMethod
  }, children);
};

Button.defaultProps = {
  disabled: false
};
Button.propTypes = {
  disabled: _propTypes["default"].bool,

  /** the button label */
  children: _propTypes["default"].any.isRequired,

  /** a funciton that handles the onClick event */
  onClickMethod: _propTypes["default"].func
};
var _default = Button;
exports["default"] = _default;